var React = require('react');

function Neuchatel (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("path",{"fill":"#E8423F","d":"M311.473.815H466.82v468.21H311.473z","key":0}),React.createElement("path",{"fill":"#FFF","d":"M155.488.815h155.97v468.21h-155.97z","key":1}),React.createElement("path",{"fill":"#16A74E","d":"M.183.815h155.332v468.21H.183z","key":2}),React.createElement("path",{"fill":"#FFF","d":"M330.165 71.029v17.405h53.137v53.15h17.44v-53.15h53.137V71.029h-53.137V17.88h-17.44v53.149z","key":3})]));
}

Neuchatel.defaultProps = {"viewBox":"0 0 467 470"};

module.exports = Neuchatel;

Neuchatel.default = Neuchatel;
